import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type InvoiceStatus = "all" | "paid" | "unpaid";

interface BillingState {
	filterStatus: InvoiceStatus;
}

const initialState: BillingState = {
	filterStatus: "all",
};

const billingSlice = createSlice({
	name: "billing",
	initialState,
	reducers: {
		setFilterStatus: (state, action: PayloadAction<InvoiceStatus>) => {
			state.filterStatus = action.payload;
		},
	},
});

export const { setFilterStatus } = billingSlice.actions;
export default billingSlice.reducer;
